import { createRootRoute } from '@tanstack/react-router';
import { AlertProvider } from '@selfinspectionorg/ui-kit';
import { AuthProvider, MaintenanceGuard } from '@selfinspectionorg/auth/react';
import { MaintenancePage } from '@selfinspectionorg/ui-kit/pages';
import styles from './__root.module.scss';
import { useAuthRedirect } from '@/app/useAuthRedirect';
import { authClient } from '@/shared/api/auth';
import { FullscreenLoader } from '@/components/ui';
import { Layout } from '@/components/layouts';

// Runs the guest→authorized redirect; must sit below AuthProvider so `useIsAuthorized` resolves.
function AppContent() {
  useAuthRedirect();

  return <Layout />;
}

function RootComponent() {
  return (
    <MaintenanceGuard client={authClient} fallback={<MaintenancePage className={styles.maintenancePage} />}>
      <AuthProvider client={authClient} loader={<FullscreenLoader />}>
        {/* App-wide toast alerts (ui-kit). Feedback like "Profile updated" surfaces here instead of
          inline card text. */}
        <AlertProvider>
          <AppContent />
        </AlertProvider>
      </AuthProvider>
    </MaintenanceGuard>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
});
